/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import PropTypes from "prop-types";
import { ADMIN_ROLE, DATA_TEAM_ROLE } from "consts";
import Table from "components/Table";
import Button from "components/Button";
import PermissionValidator from "components/PermissionValidator";

function HYFundAssociationTable({ funds, onRequestDelete }) {
  return funds.length ? (
    <Table
      data={funds}
      rowKey="fund_id"
      columns={[
        {
          title: "Fund",
          dataIndex: "fund_id.long_name",
          key: "fund_id.long_name",
        },
        {
          title: "Actions",
          dataIndex: "",
          key: "",
          width: 100,
          render: (item) => (
            <PermissionValidator
              allowedFor={[ADMIN_ROLE, DATA_TEAM_ROLE]}
              shouldHide
            >
              <Button
                size="sm"
                icon="trash"
                intent="none"
                onClick={() => onRequestDelete(item)}
              />
            </PermissionValidator>
          ),
        },
      ]}
    />
  ) : null;
}

HYFundAssociationTable.propTypes = {
  funds: PropTypes.arrayOf(PropTypes.number),
  onRequestDelete: PropTypes.func.isRequired,
};

HYFundAssociationTable.defaultProps = {
  funds: [],
};

export default HYFundAssociationTable;
